import React from 'react';
import { Sparkles, Calendar, MapPin, Users, Check, Plane } from 'lucide-react';

const georgieGroepsreis = {
  id: 'georgie-2026',
  naam: '🇬🇪 Georgië Boutique Groepsreis',
  periode: '11 – 22 oktober 2026',
  dagen: 12,
  prijsEarlyBird: 1499,
  prijsReguliere: 1599,
  tagline: '🍷 Wijn · ⛰️ Bergen · 🏡 Boutique Hotels · 🌿 Hidden Gems',
  intro: '12 dagen door het mooiste van Georgië met een kleine gezellige groep.',
  image_url: 'https://images.unsplash.com/photo-1594766722982-fb4cd139ee7c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxnZW9yZ2lhJTIwa2F6YmVnaSUyMGNodXJjaCUyMG1vdW50YWlucyUyMGVwaWN8ZW58MHx8fHwxNzc2Mzc1NzkwfDA&ixlib=rb-4.1.0&q=85',
  waarom: [
    'Kleine groep',
    'Unieke accommodaties',
    'Wijnproeverijen & gastronomie',
    'Indrukwekkende berglandschappen',
    'Mix van avontuur en ontspanning',
  ],
  hoogtepunten: [
    '🍷 Kakheti wijnregio',
    '⛰️ Kazbegi & Caucasus bergen',
    '🚙 Jeeptour naar Gergeti Church',
    '🌿 Martvili Canyon boottocht',
    '🏙️ Tbilisi city experience',
    '🥂 Traditioneel Georgisch supra diner',
  ],
  route: 'Tbilisi → Kazbegi → Kakheti → Kutaisi → Mtskheta',
  inclusief: [
    'Accommodaties',
    'Transfers in Georgië',
    'Wijnproeverij',
    'Supra diner',
    'Kazbegi jeeptour',
    'Martvili Canyon boottocht',
    'Diverse excursies & entrees',
  ],
  voorWie: 'Voor reizigers tussen ongeveer 18–35 jaar die houden van natuur, gezelligheid, cultuur, wijn en bijzondere plekken buiten de gebaande paden.',
};

const Groepsreizen = () => {
  const handleWhatsApp = () => {
    const message = `Hoi! Ik heb interesse in de Georgië Boutique Groepsreis (11–22 oktober 2026). Kun je mij meer vertellen?`;
    const whatsappUrl = `https://wa.me/+31624359764?text=${encodeURIComponent(message)}`;
    window.location.href = whatsappUrl;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white">
      {/* Hero */}
      <section
        className="relative py-24 text-white overflow-hidden"
        style={{
          backgroundImage: `linear-gradient(rgba(13, 27, 62, 0.75), rgba(13, 27, 62, 0.75)), url(${georgieGroepsreis.image_url})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 bg-yellow-400/20 backdrop-blur-sm border border-yellow-400/40 px-4 py-2 rounded-full mb-6">
              <Sparkles className="w-5 h-5 text-yellow-300" />
              <span className="text-sm font-semibold text-yellow-200 uppercase tracking-wide">Groepsreis 2026</span>
            </div>
            <h1 className="text-4xl md:text-6xl font-bold mb-4">
              Groepsreizen
            </h1>
            <p className="text-xl md:text-2xl text-blue-100">
              Reis samen met een kleine groep gelijkgestemden naar bijzondere bestemmingen.
            </p>
          </div>
        </div>
      </section>

      {/* Georgië Trip Card */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto bg-white rounded-3xl shadow-2xl overflow-hidden">
            {/* Image header */}
            <div
              className="h-80 md:h-96 relative"
              style={{
                backgroundImage: `url(${georgieGroepsreis.image_url})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-t from-blue-950/90 via-blue-900/30 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                <div className="flex flex-wrap items-center gap-3 mb-3">
                  <span className="inline-flex items-center gap-1 bg-yellow-400 text-blue-950 px-3 py-1 rounded-full text-sm font-bold">
                    <Calendar className="w-4 h-4" />
                    {georgieGroepsreis.periode}
                  </span>
                  <span className="inline-flex items-center gap-1 bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full text-sm font-semibold">
                    {georgieGroepsreis.dagen} dagen
                  </span>
                </div>
                <h2 className="text-3xl md:text-5xl font-bold mb-2">
                  {georgieGroepsreis.naam}
                </h2>
                <p className="text-lg text-blue-100">{georgieGroepsreis.tagline}</p>
              </div>
            </div>

            {/* Body */}
            <div className="p-8 md:p-12">
              <p className="text-xl text-gray-700 leading-relaxed mb-8">
                {georgieGroepsreis.intro}
              </p>

              {/* Pricing banner */}
              <div className="bg-gradient-to-r from-blue-950 to-blue-800 text-white rounded-2xl p-6 mb-10 flex flex-wrap items-center justify-between gap-4">
                <div>
                  <div className="text-sm text-yellow-200 font-semibold uppercase tracking-wide mb-1">Early Bird</div>
                  <div className="text-4xl font-bold">€{georgieGroepsreis.prijsEarlyBird} <span className="text-base font-normal text-blue-200">p.p.</span></div>
                </div>
                <div className="text-right">
                  <div className="text-sm text-blue-200 uppercase tracking-wide mb-1">Reguliere prijs</div>
                  <div className="text-2xl font-semibold text-blue-200 line-through">€{georgieGroepsreis.prijsReguliere} p.p.</div>
                </div>
              </div>

              {/* Grid: Waarom + Hoogtepunten */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-10">
                <div>
                  <h3 className="text-2xl font-bold text-blue-900 mb-4">Waarom deze reis?</h3>
                  <ul className="space-y-3">
                    {georgieGroepsreis.waarom.map((item) => (
                      <li key={item} className="flex items-start gap-3 text-gray-700">
                        <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-blue-900 mb-4">Hoogtepunten</h3>
                  <ul className="space-y-3">
                    {georgieGroepsreis.hoogtepunten.map((item) => (
                      <li key={item} className="text-gray-700">{item}</li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Route */}
              <div className="bg-blue-50 border-l-4 border-blue-900 rounded-lg p-6 mb-10">
                <div className="flex items-center gap-2 text-blue-900 font-bold text-lg mb-2">
                  <MapPin className="w-5 h-5" />
                  Route
                </div>
                <p className="text-gray-700 text-lg">{georgieGroepsreis.route}</p>
              </div>

              {/* Inclusief */}
              <div className="mb-10">
                <h3 className="text-2xl font-bold text-blue-900 mb-4">Inclusief</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {georgieGroepsreis.inclusief.map((item) => (
                    <div key={item} className="flex items-center gap-2 text-gray-700">
                      <Check className="w-5 h-5 text-green-600 flex-shrink-0" />
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Voor wie */}
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6 mb-10">
                <div className="flex items-center gap-2 text-blue-900 font-bold text-lg mb-3">
                  <Users className="w-5 h-5" />
                  Voor wie?
                </div>
                <p className="text-gray-700 leading-relaxed">{georgieGroepsreis.voorWie}</p>
              </div>

              {/* CTA */}
              <div className="text-center">
                <button
                  onClick={handleWhatsApp}
                  className="inline-flex items-center gap-2 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-500 hover:to-green-600 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all duration-300 transform hover:scale-105 shadow-xl"
                  data-testid="groepsreis-whatsapp-button"
                >
                  <Plane className="w-5 h-5" />
                  Interesse? Neem nu contact op
                </button>
                <p className="text-sm text-gray-500 mt-3">
                  📲 WhatsApp: +31 6 24359764
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Groepsreizen;
